import { Component } from '@angular/core';
import { NavController} from 'ionic-angular';
import { AppState } from '../../../../../app/app.global';
@Component({
  selector: 'login-children-page',
  templateUrl: 'byquestion.html'
})
export class VerifyByQuestionPage {

  constructor(public navCtrl: NavController,public global: AppState) {

  }
}



// WEBPACK FOOTER //
// ./src/pages/login/password/types/byquestion/byquestion.ts